<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'IndexPageLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '首页装修'
            },
            {
              key: '2',
              title: '全局样式'
            },
            {
              key: '3',
              title: '个人中心'
            },
            {
              key: '4',
              title: '旧版布局'
            }
          ],
          active: () => {
            switch (this.$route.path) {
              case '/setting/newIndexPage':
                return '1'
              case '/setting/pageStyle':
                return '2'
              case '/setting/mineIndex':
                return '3'
              case '/setting/indexPage':
                return '4'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/setting/newIndexPage')
                break
              case '2':
                this.$router.push('/setting/pageStyle')
                break
              case '3':
                this.$router.push('/setting/mineIndex')
                break
              case '4':
                this.$router.push('/setting/indexPage')
                break
              
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>